import React from 'react';
import styled from 'styled-components';
import isNil from 'lodash/isNil';
import {
  builderSetRollingControl,
  ICohortRow,
  IRowMeta,
} from '../../../../../../redux/slices/oldBuilder';
import { rowSelector } from '../../../../../../redux/selectors/builder';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import {
  RollingControlFunction,
  TimeWindowKey,
} from '../../../../../../utils/apollo/graphqlSchema';
import MeasureOptions from '../../../../Measures/MeasureOptions';
import NamedMeasureSelector from '../../../../Measures/MeasureRowHeader/NamedMeasureSelector';
import RollingControl from '../../../../Measures/RollingControl';
import { HighlightedEntity } from '../../../../../HighlightingContext';
import ThinDivider from '../../../../../ThinDivider';
import { theme } from '../../../../../../styles/theme';

interface IProps {
  rowMeta: IRowMeta;
}

const Container = styled(HighlightedEntity)`
  display: flex;
  align-items: center;
  column-gap: 16px;
  min-height: 48px;
  padding-right: 16px;
  padding-left: 16px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  background-color: ${theme.colors.tableHeader};
`;

const MeasureCohortMeasureHeader = ({ rowMeta }: IProps) => {
  const dispatch = useAppDispatch();

  const row: ICohortRow = useAppSelector((state) =>
    rowSelector(state, rowMeta),
  );

  const { showMeasure, measureRollingControl, timeWindow } = row;

  const handleAddRollingControl = (rollingFunction: RollingControlFunction) => {
    dispatch(
      builderSetRollingControl({
        rowMeta,
        value: {
          __typename: 'RollingControl',
          function: rollingFunction,
          window: 0,
        },
      }),
    );
  };

  const allowRollingControl = timeWindow === TimeWindowKey.Overall;

  return (
    <Container>
      <MeasureOptions
        rowMeta={rowMeta}
        onAddCohort={null}
        onAddRolling={allowRollingControl ? handleAddRollingControl : null}
        disableCohortOption={true}
        disableRollingOption={!isNil(measureRollingControl)}
      />
      {showMeasure && (
        <>
          <ThinDivider layout="vertical" size="short" />
          <NamedMeasureSelector
            rowMeta={rowMeta}
            cohortRow={row}
            isCohort={true}
            allowRollingControl={allowRollingControl}
            allowCompoundMeasure={true}
          />
        </>
      )}
      {measureRollingControl && (
        <>
          <ThinDivider layout="vertical" size="short" />
          <RollingControl
            rowMeta={rowMeta}
            measureRollingControl={measureRollingControl}
          />
        </>
      )}
    </Container>
  );
};

export default MeasureCohortMeasureHeader;
